/**
 * 全局路由中间件 - 自动追踪（PC项目）
 * 在每次路由切换时生成新的 traceId
 */
import { generateTraceId } from '~/utils/tracking';

export default defineNuxtRouteMiddleware((to, from) => {
  // 只在客户端执行
  if (typeof window === 'undefined') {
    return;
  }

  // 每次路由切换时生成新的 traceId
  const newTraceId = generateTraceId();
  
  // 更新 Fundebug 的 metaData（如果已初始化）
  if (typeof window !== 'undefined' && (window as any).fundebug) {
    try {
      (window as any).fundebug.metaData = {
        ...(window as any).fundebug.metaData,
        traceId: newTraceId,
        currentPath: to.path,
        fromPath: from?.path,
        timestamp: new Date().toISOString(),
      };
    } catch (e) {
      console.error('更新 Fundebug metaData 失败:', e);
    }
  }
  
  console.log(`🔄 路由切换追踪 (PC) - 新 traceId: ${newTraceId}`, {
    from: from?.path,
    to: to.path,
  });
});


